import * as React from 'react';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
  setDoc,
  doc,
  Timestamp,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { IconButton, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import { useParams } from 'react-router';
import Iconify from '../components/iconify';

import 'react-phone-input-2/lib/material.css';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function Page() {
  const [role, setRole] = React.useState('super_admin');
  const [status, setStatus] = React.useState('active');
  const [mobileNum, setMobileNum] = React.useState('');

  const [firstNameError, setFirstNameError] = React.useState(false);
  const [lastNameError, setLastNameError] = React.useState(false);
  const [emailError, setEmailError] = React.useState(false);
  const [mobileNumError, setMobileNumError] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const [eventname, setEventName] = React.useState(null);
  const [eventSubtitle, setEventSubtitle] = React.useState(null);
  const [thankyou, setThankyou] = React.useState(false);

  const navigate = useNavigate();

  const { id } = useParams();

  useEffect(() => {
    get(child(dbref(rtdb), `event/${id}`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          setEventName(snapshot.val().title);
          setEventSubtitle(snapshot.val().subtitle);
          setLoading(false);
        } else {
          setEventName(null);
          setEventSubtitle(null);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let emailPass = false;
    let firstNamePass = false;
    let lastNamePass = false;
    let mobileNumPass = false;

    const data = new FormData(event.currentTarget);

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (data.get('email').length > 0 && emailRegex.test(data.get('email'))) {
      setEmailError(false);
      emailPass = true;
    } else {
      setEmailError(true);
    }

    if (mobileNum.length > 7) {
      setMobileNumError(false);
      mobileNumPass = true;
    } else {
      setMobileNumError(true);
    }

    if (data.get('firstName').length > 1) {
      setFirstNameError(false);
      firstNamePass = true;
    } else {
      setFirstNameError(true);
    }

    if (data.get('lastName').length > 1) {
      setLastNameError(false);
      lastNamePass = true;
    } else {
      setLastNameError(true);
    }

    if (emailPass === true && firstNamePass === true && lastNamePass === true && mobileNumPass === true) {
      const UID = `ID${Timestamp.fromDate(new Date()).toMillis()}`;
      update(dbref(rtdb, `event_registration/${id}/${UID}`), {
        id: UID,
        first_name: data.get('firstName') || null,
        last_name: data.get('lastName') || null,
        email: data.get('email') || null,
        company: data.get('company') || null,
        mobile: mobileNum || null,
        created: Timestamp.fromDate(new Date()).toMillis(),
      }).then(() => {
        setLoading(false);
        setThankyou(true);
      });
    }
  };

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  if (thankyou) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            zIndex: -1,
            position: 'fixed',
            top: 0,
            backgroundColor: '#1b0049',
            height: '110vh',
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column',
          }}
        >
          <video height="100%" className="videoTag" playsInline autoPlay loop muted>
            <source src="/assets/videobg.mp4" type="video/mp4" />
          </video>
        </Grid>

        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 50,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: 'Transparent',
          }}
        >
          <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
            Registration
          </Typography>
          {eventname ? (
            <Typography
              style={{
                marginTop: -10,
                fontWeight: 'lighter',
                fontSize: 40,
                color: 'white',
                textTransform: 'uppercase',
              }}
            >
              {eventname}
            </Typography>
          ) : null}
          {eventSubtitle ? (
            <Typography style={{ maxWidth: 500, fontWeight: 300, fontSize: 14, color: 'white' }}>
              {eventSubtitle}
            </Typography>
          ) : null}
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: 'White',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 30,
            flexDirection: 'column',
          }}
        >
          <Typography align="center" style={{ fontWeight: 700, fontSize: 36 }}>
            Thank You For Your Registration.
          </Typography>
          <Typography align="center" style={{ fontSize: 12, marginTop: 15 }}>
            An email with the details about your registration has been sent to the email address provided.
          </Typography>
          <Typography align="center" style={{ fontSize: 12, marginTop: 5 }}>
            Please keep it for your records.
          </Typography>

          <Grid
            style={{
              width: '100%',
              maxWidth: 500,
              height: 2,
              borderBottom: '1px solid white',
              opacity: 0.5,
              marginTop: 20,
              marginBottom: 10,
            }}
          />

          <Typography align="center" style={{ fontSize: 12, marginTop: 15 }}>
            We're dedicated to giving you the best experience possible.
          </Typography>
          <Typography align="center" style={{ fontSize: 12, marginTop: 5 }}>
            If you have any questions please don't hesitate to contact us (+(65) 6622 5520)
          </Typography>
          <Button variant="contained" style={{ marginTop: 20 }} href={`/${id}`} disableElevation>
            Back
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Helmet>
        <title> Event Registration | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Grid
          style={{
            zIndex: -1,
            position: 'fixed',
            top: 0,
            backgroundColor: '#1b0049',
            height: '110vh',
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column',
          }}
        >
          <video height="100%" className="videoTag" playsInline autoPlay loop muted>
            <source src="/assets/videobg.mp4" type="video/mp4" />
          </video>
        </Grid>

        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 50,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: 'Transparent',
          }}
        >
          <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
            Registration
          </Typography>
          {eventname ? (
            <Typography
              style={{
                marginTop: -10,
                fontWeight: 'lighter',
                fontSize: 40,
                color: 'white',
                textTransform: 'uppercase',
              }}
            >
              {eventname}
            </Typography>
          ) : null}
          {eventSubtitle ? (
            <Typography style={{ maxWidth: 500, fontWeight: 300, fontSize: 14, color: 'white' }}>
              {eventSubtitle}
            </Typography>
          ) : null}
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: 'White',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          {eventname ? (
            <Box component="form" noValidate onSubmit={handleSubmit} style={{ maxWidth: 600, padding: 30 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="given-name"
                    name="firstName"
                    required
                    error={firstNameError}
                    fullWidth
                    id="firstName"
                    label="First Name"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    error={lastNameError}
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField fullWidth id="company" label="Company" name="company" autoComplete="company-name" />
                  <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. One T Pte Ltd </Typography>
                </Grid>

                <Grid item xs={12}>
                  <PhoneInput
                    fullWidth
                    country="sg"
                    inputStyle={{ width: '100%' }}
                    searchStyle={{ width: '100%' }}
                    style={{ margin: 0, marginTop: 15, width: '100%' }}
                    value={mobileNum}
                    onChange={handleChangeMobileNum}
                  />
                  <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. +65 2345 6789 </Typography>
                  {mobileNumError ? (
                    <Typography style={{ fontSize: 11, color: 'red' }}>Mobile Number Invalid</Typography>
                  ) : null}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    id="email"
                    error={emailError}
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                  />
                  <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. abc@gmail.com </Typography>
                </Grid>
              </Grid>
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                Submit
              </Button>
            </Box>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
}
